import uniqueId from '@form-create/utils/lib/unique';

const label = '化学分子式';
const name = 'x-ketcher';

export default {
    icon: 'el-icon-share',
    label,
    name,
    rule() {
        return {
            type: name,
            field: uniqueId(),
            title: label,
            info: '',
            props: {}
        };
    },
    props() {
        return [];
    }
};